export const BLADE_ARTWORK = {
  TikTok: "01_tiktok_blade_art_overlay.png",
  YouTube: "02_youtube_blade_art_overlay.png",
  Twitch: "03_twitch_blade_art_overlay.png",
  mindSHARE: "04_mindshare_active_hero_overlay.png",
  Steam: "05_steam_blade_art_overlay.png",
  Xbox: "06_xbox_blade_art_overlay.png",
  Discord: "07_discord_blade_art_overlay.png",
};

export const bladeArtworkUrl = source =>
  `${process.env.PUBLIC_URL}/redesign/images/redesign/blade_v2/${BLADE_ARTWORK[source]}`;
